/* eslint-disable @typescript-eslint/camelcase */
import { FcsFlag } from "@/feature-flags/unleash";

export const FlagsPermissionDutyTax = {
  duty_tax_configuration_enable: new FcsFlag.Flag(false)
};

export function initFlagsPermissionDutyTax(): void {
  FcsFlag.register("featurePermissionDutyTax", FlagsPermissionDutyTax);
}
